/* @flow */
import React from 'react';

import ChatMessage from 'entities/ChatMessage';
import Message from 'entities/Message';
import TextEntities from 'lib/TextEntities';
import TextWithEntities from 'components/TextWithEntities.jsx';

const ChatMessageSnippet = ({ message }: {message: ChatMessage|Message}) => {
  const preview = message.getPreview();
  if (preview) {
    const entities = TextEntities.parseEmoji(preview);
    return <TextWithEntities text={preview} entities={entities} />;
  }
  // UNTIL 0.15 https://github.com/facebook/react/issues/5355
  return <noscript />;
};

ChatMessageSnippet.propTypes = {
  message: React.PropTypes.oneOfType([
    React.PropTypes.instanceOf(ChatMessage),
    React.PropTypes.instanceOf(Message),
  ]).isRequired,
};

export default ChatMessageSnippet;



// WEBPACK FOOTER //
// ./src/chat/components/ChatMessageSnippet.jsx